export const MACRO_FIELDS = `
    id
    _id
    _deleted
    name
    version
    content
    description
    modified
    categories
    linked
    history {
        version
        name
        content
        changedAt
        changedBy
    }
`
